import React from 'react';
import { Paper } from '@material-ui/core';
import styled from 'styled-components';
import { compose, spacing, display } from '@material-ui/system';

const StyledPaper = styled(Paper)(compose(spacing, display));

export default function PaperComponent (props) {
  return <StyledPaper {...props} />;
};
